import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FiCheck, FiX, FiInfo } from 'react-icons/fi';
import useSWR, { mutate as mutateGlobal } from 'swr';
import * as Yup from 'yup';
import { Form } from '@unform/web';

import { format } from 'date-fns';

import getValidationErrors from '../../../utils/getValidationErrors';
import validatorBiggerZero from '../../../utils/validatorBiggerZero';
import { parseStrToFloatInputBRL } from '../../../utils/parseStrToFloatInputBRL';
import {
  formatedInputBRL,
  formatedInputDatePicker,
} from '../../../utils/formatedInputs';

import api from '../../../services/api';

import { useAuth } from '../../../hooks/auth';
import { useToast } from '../../../hooks/toast';
import { useFetch } from '../../../hooks/useFetch';

import NavBarMenu from '../../../components/NavbarMenu';
import ContainerBox from '../../../components/ContainerBox';
import {
  Input,
  Select,
  InputDatePicker,
  CheckBox,
  InputBRL,
  TextArea,
} from '../../../components/Form';
import ButtonSave from '../../../components/ButtonPrimaryBlue';
import ButtonCancel from '../../../components/ButtonCancel';
import Loading from '../../../components/Loading';

import {
  ButtonGroup,
  GroupFields,
  GroupFieldsCol1,
  GroupFieldsCol4,
  ContentForm,
  Col1,
  Col2,
  Hr,
  Info,
} from './styles';

const BillsToPayNewEdit = () => {
  const { user } = useAuth();

  const { data } = useSWR(
    `/billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`
  );
  const { dataList: accountPlans } = useFetch('/accountplansearch?search=%');
  const { dataList: accounts } = useFetch('/accountsearch?search=%');
  const { dataList: providers } = useFetch('/peoplesearch?search=%');
  const { dataList: coastcenters } = useFetch('/coastcentersearch?search=%');

  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paid, setPaid] = useState(false);
  const [paidPartial, setPaidPartial] = useState(false);
  const [togglePaid, setTogglePaid] = useState(false);
  const [confereceAmountPay, setConferenceAmountPay] = useState(0);
  const [restAmountPay, setRestAmountPay] = useState(0);

  const location = useLocation();

  const history = useHistory();

  const formRef = useRef(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (!location.state) {
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      const response = await api.get(`/billstopays/${location.state.item.id}`);

      const dataBills = response.data;

      const dataBillsToPay = {
        description: dataBills.description,
        account_plan_id: String(dataBills.account_plan_id),
        account_id: String(dataBills.account_id),

        competency_date: formatedInputDatePicker(dataBills.competency_date),

        maturity_date: formatedInputDatePicker(dataBills.maturity_date),
        amount: dataBills.amount && formatedInputBRL(dataBills.amount),
        paid: dataBills.paid,
        paid_partial: dataBills.paid_partial,

        payment_date:
          dataBills.payment_date &&
          formatedInputDatePicker(dataBills.payment_date),
        discount: dataBills.discount
          ? formatedInputBRL(dataBills.discount)
          : '',
        interest: dataBills.interest
          ? formatedInputBRL(dataBills.interest)
          : '',
        payment_amount: dataBills.payment_amount
          ? formatedInputBRL(dataBills.payment_amount)
          : '',
        people_id: dataBills.people_id ? String(dataBills.people_id) : null,
        coast_center_id:
          dataBills.coast_center_id && String(dataBills.coast_center_id),
        comments: dataBills.comments,
      };

      setLoading(false);

      if (dataBillsToPay.paid) {
        const amountPay =
          parseStrToFloatInputBRL(dataBillsToPay.payment_amount).toFixed(2) * 1;

        setConferenceAmountPay(+amountPay);
      }

      setPaidPartial(dataBillsToPay.paid_partial);
      setPaid(dataBillsToPay.paid);
      setTogglePaid(dataBills.paid);

      formRef.current.setData(dataBillsToPay);
    };

    fetchData();

    setId(location.state.item.id);
  }, [location.state]);

  useEffect(() => {
    const descriptionInput = formRef.current.getFieldRef('description');

    descriptionInput.focus();
  }, []);

  const handleSubmit = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          description: Yup.string().required('Descrição é obrigatório'),
          account_plan_id: Yup.string().required(
            'Plano de contas é obrigatório'
          ),
          account_id: Yup.string().required('Conta é obrigatório'),
          competency_date: Yup.date().required(
            'Data competência é obrigatório'
          ),
          maturity_date: Yup.string().required('Data vencimento obrigatório'),

          amount: Yup.string()
            .test(
              'testAmountBiggerZero',
              'Valor deve ser maior que zero',
              (value) => validatorBiggerZero(value)
            )
            .required('Valor é obrigatório'),
          coast_center_id: Yup.string().required(
            'Centro de custo é obrigatório'
          ),
          payment_amount: Yup.string().when('paid', {
            is: (val) => val === true,
            then: Yup.string()
              .test(
                'testAmountBiggerZero',
                'Valor deve ser maior que zero',
                (value) => validatorBiggerZero(value)
              )
              .required('Valor de pagamento é obrigatório'),
            otherwise: Yup.string(),
          }),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        const competency = format(dataForm.competency_date, 'yyyy-MM-dd');
        const maturity = format(dataForm.maturity_date, 'yyyy-MM-dd');

        if (competency > maturity) {
          addToast({
            type: 'error',
            title: 'Erro: Data compentência maior que data Vencimento!',
          });
          return;
        }

        if (
          parseStrToFloatInputBRL(dataForm.payment_amount).toFixed(2) * 1 >
          confereceAmountPay
        ) {
          addToast({
            type: 'error',
            title: 'Erro: Valor do pagamento maior que o Lançamento',
          });
          return;
        }

        if (paid && paidPartial) {
          const dataBillsToPay = {
            description: dataForm.description,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),

            paid_partial: true,

            payment_date:
              dataForm.payment_date && new Date(dataForm.payment_date),
            discount: dataForm.discount
              ? parseStrToFloatInputBRL(dataForm.discount)
              : null,
            interest: dataForm.interest
              ? parseStrToFloatInputBRL(dataForm.interest)
              : null,
            payment_amount: dataForm.payment_amount
              ? parseStrToFloatInputBRL(dataForm.payment_amount)
              : null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          const billsPayment = await api.post('billstopays', dataBillsToPay);

          const billToPayLaunched = {
            bills_to_pay_id: billsPayment.data.id,
            user_id: user.id,
          };

          await api.post(`/launchdebitaccount`, billToPayLaunched);

          const dataBillsToPayREST = {
            description: `${dataForm.description} *`,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: restAmountPay,
            paid: false,
            paid_partial: false,
            payment_date: null,
            discount: null,
            interest: null,
            payment_amount: null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          await api.post('billstopays', dataBillsToPayREST);

          mutateGlobal(`billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`);

          addToast({
            type: 'success',
            title: 'Cadastro e Restante efetuado com Sucesso',
          });

          history.push('/billstopays');
          return;
        }

        if (paid && !paidPartial) {
          const dataBillsToPay = {
            description: dataForm.description,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),

            paid_partial: null,

            discount: dataForm.discount
              ? parseStrToFloatInputBRL(dataForm.discount)
              : null,
            interest: dataForm.interest
              ? parseStrToFloatInputBRL(dataForm.interest)
              : null,
            payment_amount: dataForm.payment_amount
              ? parseStrToFloatInputBRL(dataForm.payment_amount)
              : null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          const billsPayment = await api.post('billstopays', dataBillsToPay);

          const billToPayLaunched = {
            bills_to_pay_id: billsPayment.data.id,
            user_id: user.id,
          };

          await api.post(`/launchdebitaccount`, billToPayLaunched);

          mutateGlobal(`billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`);

          addToast({
            type: 'success',
            title: 'Cadastro efetuado com Sucesso',
          });

          history.push('/billstopays');
          return;
        }

        const dataBillsToPay = {
          description: dataForm.description,
          account_plan_id: parseInt(dataForm.account_plan_id, 10),
          account_id: dataForm.account_id && parseInt(dataForm.account_id, 10),
          competency_date: new Date(dataForm.competency_date),
          maturity_date: new Date(dataForm.maturity_date),
          amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),
          paid: dataForm.paid,
          paid_partial: null,
          payment_date:
            dataForm.payment_date && new Date(dataForm.payment_date),
          discount: dataForm.discount
            ? parseStrToFloatInputBRL(dataForm.discount)
            : null,
          interest: dataForm.interest
            ? parseStrToFloatInputBRL(dataForm.interest)
            : null,
          payment_amount: dataForm.payment_amount
            ? parseStrToFloatInputBRL(dataForm.payment_amount)
            : null,
          people_id: dataForm.people_id
            ? parseInt(dataForm.people_id, 10)
            : null,
          coast_center_id:
            dataForm.coast_center_id && parseInt(dataForm.coast_center_id, 10),
          comments: dataForm.comments,
        };

        mutateGlobal(
          `/billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`,
          [...data, dataBillsToPay],
          false
        );
        await api.post('billstopays', dataBillsToPay);

        addToast({
          type: 'success',
          title: 'Cadastro efetuado com Sucesso',
        });

        history.push('/billstopays');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Descrição já cadastrada',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [
      addToast,
      history,
      data,
      paid,
      paidPartial,
      restAmountPay,
      confereceAmountPay,
      user.id,
    ]
  );

  const handleUpdate = useCallback(
    async (dataForm) => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          description: Yup.string().required('Descrição é obrigatório'),
          account_plan_id: Yup.string().required(
            'Plano de contas é obrigatório'
          ),
          account_id: Yup.string().required('Conta é obrigatório'),
          competency_date: Yup.date().required(
            'Data competência é obrigatório'
          ),
          maturity_date: Yup.date().required('Data vencimento é obrigatório'),

          amount: Yup.string()
            .test(
              'testAmountBiggerZero',
              'Valor deve ser maior que zero',
              (value) => validatorBiggerZero(value)
            )
            .required('Valor é obrigatório'),
          coast_center_id: Yup.string().required(
            'Centro de custo é obrigatório'
          ),
          payment_amount: Yup.string().when('paid', {
            is: (val) => val === true,
            then: Yup.string()
              .test(
                'testAmountBiggerZero',
                'Valor deve ser maior que zero',
                (value) => validatorBiggerZero(value)
              )
              .required('Valor de pagamento é obrigatório'),
            otherwise: Yup.string(),
          }),
        });

        await schema.validate(dataForm, {
          abortEarly: false,
        });

        const competency = format(dataForm.competency_date, 'yyyy-MM-dd');
        const maturity = format(dataForm.maturity_date, 'yyyy-MM-dd');

        if (competency > maturity) {
          addToast({
            type: 'error',
            title: 'Erro: Data compentência maior que data Vencimento!',
          });
          return;
        }

        if (
          parseStrToFloatInputBRL(dataForm.payment_amount).toFixed(2) * 1 >
          confereceAmountPay
        ) {
          addToast({
            type: 'error',
            title: 'Erro: Valor do pagamento maior que o Lançamento',
          });
          return;
        }

        if (paid && paidPartial) {
          const dataBillsToPay = {
            description: dataForm.description,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),
            paid_partial: true,
            discount: dataForm.discount
              ? parseStrToFloatInputBRL(dataForm.discount)
              : null,
            interest: dataForm.interest
              ? parseStrToFloatInputBRL(dataForm.interest)
              : null,
            payment_amount: dataForm.payment_amount
              ? parseStrToFloatInputBRL(dataForm.payment_amount)
              : null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          await api.patch(`billstopays/${id}`, dataBillsToPay);

          const billsPaymentUpdated = await api.get(`billstopays/${id}`);

          const billToPaymentLaunched = {
            bills_to_pay_id: billsPaymentUpdated.data.id,
            user_id: user.id,
          };

          await api.post(`/launchdebitaccount`, billToPaymentLaunched);

          const dataBillsToPayREST = {
            description: `${dataForm.description} *`,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: restAmountPay,
            paid: false,
            paid_partial: false,
            payment_date: null,
            discount: null,
            interest: null,
            payment_amount: null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          await api.post('billstopays', dataBillsToPayREST);

          mutateGlobal(`billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`);

          addToast({
            type: 'success',
            title: 'Edição e Restante efetuado com Sucesso',
          });

          history.push('/billstopays');
          return;
        }

        if (paid && !paidPartial) {
          const dataBillsToPay = {
            description: dataForm.description,
            account_plan_id: parseInt(dataForm.account_plan_id, 10),
            account_id:
              dataForm.account_id && parseInt(dataForm.account_id, 10),
            competency_date: new Date(dataForm.competency_date),
            maturity_date: new Date(dataForm.maturity_date),
            amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),
            paid_partial: null,
            discount: dataForm.discount
              ? parseStrToFloatInputBRL(dataForm.discount)
              : null,
            interest: dataForm.interest
              ? parseStrToFloatInputBRL(dataForm.interest)
              : null,
            payment_amount: dataForm.payment_amount
              ? parseStrToFloatInputBRL(dataForm.payment_amount)
              : null,
            people_id: dataForm.people_id
              ? parseInt(dataForm.people_id, 10)
              : null,
            coast_center_id:
              dataForm.coast_center_id &&
              parseInt(dataForm.coast_center_id, 10),
            comments: dataForm.comments,
          };

          await api.patch(`billstopays/${id}`, dataBillsToPay);

          const billsPaymentUpdated = await api.get(`billstopays/${id}`);

          const billToPaymentLaunched = {
            bills_to_pay_id: billsPaymentUpdated.data.id,
            user_id: user.id,
          };

          await api.post(`/launchdebitaccount`, billToPaymentLaunched);

          mutateGlobal(`billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`);

          addToast({
            type: 'success',
            title: 'Edição efetuado com Sucesso',
          });

          history.push('/billstopays');
          return;
        }

        const dataBillsToPay = {
          description: dataForm.description,
          account_plan_id: parseInt(dataForm.account_plan_id, 10),
          account_id: dataForm.account_id && parseInt(dataForm.account_id, 10),
          competency_date: new Date(dataForm.competency_date),
          maturity_date: new Date(dataForm.maturity_date),
          amount: dataForm.amount && parseStrToFloatInputBRL(dataForm.amount),
          paid: dataForm.paid,
          paid_partial: null,
          payment_date:
            dataForm.payment_date && new Date(dataForm.payment_date),
          discount: dataForm.discount
            ? parseStrToFloatInputBRL(dataForm.discount)
            : null,
          interest: dataForm.interest
            ? parseStrToFloatInputBRL(dataForm.interest)
            : null,
          payment_amount: dataForm.payment_amount
            ? parseStrToFloatInputBRL(dataForm.payment_amount)
            : null,
          people_id: dataForm.people_id
            ? parseInt(dataForm.people_id, 10)
            : null,
          coast_center_id:
            dataForm.coast_center_id && parseInt(dataForm.coast_center_id, 10),
          comments: dataForm.comments,
        };

        await api.patch(`billstopays/${id}`, dataBillsToPay);

        mutateGlobal(`billstopays?month=${format(new Date(), 'yyyy-MM-dd')}`);

        addToast({
          type: 'success',
          title: 'Cadastro editado com Sucesso',
        });

        history.push('/billstopays');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current.setErrors(errors);
          return;
        }

        if (err.response.status === 403) {
          addToast({
            type: 'error',
            description: 'Descrição já cadastrada',
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description: 'Verifique os dados.',
        });
      }
    },
    [
      addToast,
      history,
      paid,
      paidPartial,
      restAmountPay,
      id,
      confereceAmountPay,
      user.id,
    ]
  );

  const handleCalculatorFinalPayment = useCallback(() => {
    if (!paid) return;

    const amount = formRef.current.getFieldValue('amount');
    const discount = formRef.current.getFieldValue('discount');
    const interest = formRef.current.getFieldValue('interest');

    const amountFloat = parseStrToFloatInputBRL(amount) * 1;
    const discountFloat = parseStrToFloatInputBRL(discount) * 1;
    const interestFloat = parseStrToFloatInputBRL(interest) * 1;

    const amountPay = (amountFloat + interestFloat - discountFloat).toFixed(2);
    setConferenceAmountPay(amountPay);

    const amountPayFormated = formatedInputBRL(amountPay);

    formRef.current.setFieldValue('payment_amount', amountPayFormated);
  }, [paid]);

  const handleConfereceFinalPayment = useCallback(() => {
    if (!paid) return;

    const amountPay = formRef.current.getFieldValue('payment_amount');
    const amountPayFloat = parseStrToFloatInputBRL(amountPay);

    if (+amountPayFloat > +confereceAmountPay) {
      addToast({
        type: 'error',
        title: 'Valor Pago incorreto',
        description: 'Erro: Valor do pagamento incorreto. Verifique!',
      });
      return;
    }
    if (+amountPayFloat <= 0) {
      addToast({
        type: 'error',
        title: 'Valor Pago incorreto',
        description: 'Valor pago tem que ser maior que zero',
      });
      return;
    }
    if (+amountPayFloat < +confereceAmountPay) {
      setPaidPartial(true);

      const restAmoutPayment = (+confereceAmountPay - +amountPayFloat).toFixed(
        2
      );

      setRestAmountPay(restAmoutPayment);

      addToast({
        type: 'info',
        title: 'Atenção: Valor pago menor que valor',
        description: 'Será criado um novo lançamento com o restante.',
      });
    }
  }, [paid, confereceAmountPay, addToast]);

  const handleCheckBoxPaid = useCallback((e) => {
    if (e.target.checked) {
      setPaid(true);
      const amount = formRef.current.getFieldValue('amount');
      formRef.current.setFieldValue('payment_amount', amount);

      const amountPayFloat = parseStrToFloatInputBRL(amount);
      setConferenceAmountPay(+amountPayFloat);
    } else {
      setPaid(false);
      setPaidPartial(false);
      formRef.current.setFieldValue('discount', '');
      formRef.current.setFieldValue('interest', '');
      formRef.current.setFieldValue('payment_amount', '');
      setConferenceAmountPay(0);
      setRestAmountPay(0);
    }
  }, []);

  const handleEnter = useCallback((e) => {
    if (e.keyCode === 13) e.preventDefault();
  }, []);

  return (
    <>
      <NavBarMenu />
      {loading && <Loading />}
      {!loading && (
        <ContainerBox
          title={location.state ? 'Editar Pagamento' : 'Novo Pagamento'}
        >
          {togglePaid && (
            <Info>
              <FiInfo color="#2196f3" size={22} />
              Para editar pagamentos já pagos é necessário estorná-los
            </Info>
          )}

          <Form
            ref={formRef}
            onSubmit={location.state ? handleUpdate : handleSubmit}
            onKeyDown={(e) => handleEnter(e)}
          >
            <ContentForm noactive={togglePaid}>
              <Col1>
                <GroupFields>
                  <Input
                    id="description"
                    name="description"
                    label="Descrição*"
                    autoComplete="off"
                  />
                  <Select
                    label="Plano de Contas*"
                    name="account_plan_id"
                    id="account_plan_id"
                  >
                    <option value="">Selecione o Plano de Contas</option>
                    {accountPlans &&
                      accountPlans
                        .filter((item) => item.type === 'd')
                        .map((acc) => (
                          <option key={acc.id} value={acc.id}>
                            {acc.name}
                          </option>
                        ))}
                  </Select>
                </GroupFields>

                <GroupFieldsCol4>
                  <Select label="Conta*" name="account_id" id="account_id">
                    <option value="">Selecione a Conta</option>
                    {accounts &&
                      accounts.map((acc) => (
                        <option key={acc.id} value={acc.id}>
                          {acc.description}
                        </option>
                      ))}
                  </Select>

                  <InputDatePicker
                    name="competency_date"
                    id="competency_date"
                    label="Data Competência*"
                  />
                  <InputDatePicker
                    name="maturity_date"
                    id="maturity_date"
                    label="Data Vencimento*"
                  />
                  <InputBRL
                    name="amount"
                    id="amount"
                    label="Valor:*"
                    placeholder="R$"
                    className={!paid ? '' : 'noactive'}
                    onBlur={handleCalculatorFinalPayment}
                  />
                </GroupFieldsCol4>

                <Hr />

                <GroupFields style={{ marginTop: 16, marginBottom: 16 }}>
                  <CheckBox
                    name="paid"
                    id="paid"
                    label={paidPartial ? 'Pago - PARCIALMENTE' : 'Pago'}
                    onChange={(e) => handleCheckBoxPaid(e)}
                  />
                </GroupFields>

                <GroupFieldsCol4>
                  <InputDatePicker
                    name="payment_date"
                    id="payment_date"
                    label="Data Pagamento"
                    className={paid ? '' : 'noactive'}
                  />
                  <InputBRL
                    name="discount"
                    id="discount"
                    label="Desconto"
                    placeholder="R$"
                    className={paid ? '' : 'noactive'}
                    onBlur={handleCalculatorFinalPayment}
                  />
                  <InputBRL
                    name="interest"
                    id="interest"
                    label="Juros / Multas"
                    placeholder="R$"
                    className={paid ? '' : 'noactive'}
                    onBlur={handleCalculatorFinalPayment}
                  />
                  <InputBRL
                    name="payment_amount"
                    id="payment_amount"
                    label="Valor Pago"
                    placeholder="R$"
                    className={paid ? '' : 'noactive'}
                    onBlur={handleConfereceFinalPayment}
                  />
                </GroupFieldsCol4>
              </Col1>
              <Col2>
                <GroupFieldsCol1>
                  <Select label="Fornecedor:" name="people_id" id="people_id">
                    <option value="">Selecione o Fornecedor</option>
                    {providers &&
                      providers
                        .filter(
                          (item) => item.provider || item.shipping_company
                        )
                        .map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.pf?.name || p.pj?.fantasy_name}
                          </option>
                        ))}
                  </Select>
                  <div style={{ marginTop: 24 }}>
                    <Select
                      label="Centro de Custos:*"
                      name="coast_center_id"
                      id="coast_center_id"
                    >
                      <option value="">Selecione o Centro de Custo</option>
                      {coastcenters &&
                        coastcenters.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                    </Select>
                  </div>
                  <div style={{ marginTop: 24 }}>
                    <TextArea
                      style={{ marginTop: 0 }}
                      rows="3"
                      id="comments"
                      name="comments"
                      label="Observações:"
                      autoComplete="off"
                    />
                  </div>
                </GroupFieldsCol1>
              </Col2>
            </ContentForm>
            <Hr />

            <ButtonGroup>
              {!togglePaid && <ButtonSave icon={FiCheck}>Salvar</ButtonSave>}
              <Link to="/billstopays">
                <ButtonCancel icon={FiX}>Cancelar</ButtonCancel>
              </Link>
            </ButtonGroup>
          </Form>
        </ContainerBox>
      )}
    </>
  );
};

export default BillsToPayNewEdit;
